import { InMemoryCache } from '@apollo/client';
import fragmentSchema from './Schema.json';

const CreateApolloCache = () => {
  let fragmentMatcher = { match: (_idValue, _typeCondition, _context) => false };

  if (fragmentSchema) {
    fragmentMatcher = new InMemoryCache({
      introspectionQueryResultData: {
        __schema: {
          types: fragmentSchema,
        },
      },
    });
  }

  return new InMemoryCache({ fragmentMatcher });
};

export default CreateApolloCache;
